import Swiper from "swiper";
import "swiper/css/swiper.min.css";

// import Swiper from "swiper";
// import "swiper/css/swiper.min.css";

let swiperLooks;
let swiperVideos;

let swiperLooksLeft;
let swiperLooksRight;

export const cleanSliders = () => {
  // swiperLooks && swiperLooks.destroy();
};

/******************************************************************************/

export const initSliderLooks = () => {
  const el = document.querySelector(".swiper-looks");
  if (!el) return;

  const swiperLooksOpt = {
    spaceBetween: 20,
    slidesPerView: 1,
    // centeredSlides: true,
    mousewheel: {
      sensitivity: 0.5
    },
    freeMode: true,
    freeModeMomentumRatio: 0.3,
    freeModeMomentumVelocityRatio: 0.25,
    // freeModeSticky: true,
    navigation: {
      nextEl: ".swiper-looks .swiper-button-next",
      prevEl: ".swiper-looks .swiper-button-prev"
    },
    breakpoints: {
      // when window width is >= 320px
      768: {
        spaceBetween: 16,
        slidesPerView: "auto",
      },
      // when window width is >= 480px
      1024: {
        spaceBetween: 20,
        slidesPerView: "auto",
      },
    }
  };

  swiperLooks = new Swiper(el, swiperLooksOpt);
  //swiperLooks.on("slideChange", slideChange);
};

/******************************************************************************/

export const initSliderVideos = () => {
  const el = document.querySelector(".swiper-videos");
  if (!el) return;

  const swiperVideosOpt = {
    spaceBetween: 0,
    slidesPerView: 1,
    // centeredSlides: true,
    // watchOverflow: true,

    // freeModeSticky: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };

  swiperVideos = new Swiper(el, swiperVideosOpt);
  swiperVideos.on("slideChange", slideVideoChange);
};

const slideVideoChange = e => {
  swiperVideos.slides.each((i, s) => {
    let video = s.querySelector("video");
    video && video.pause();
  });
};

/******************************************************************************/

const slideLeftChange = init => {
  
  const prev = document.querySelector(".swiper-looks-left .prev-look");
  const next = document.querySelector(".swiper-looks-left .next-look");

  const index = swiperLooksLeft.realIndex + 1;
  prev.innerHTML = (new String(index-1)).padStart(2, '0');
  next.innerHTML = (new String(index+1)).padStart(2, '0');

  !init && swiperLooks && swiperLooks.slideTo(index);

  

};

export const initSliderLooksDetails = () => {

  const elRight = document.querySelector(".swiper-looks-right");
  if (!elRight) return;

  const swiperLooksRightOpt = {
    spaceBetween: 0,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
   
  };

  swiperLooksRight = new Swiper(elRight, swiperLooksRightOpt);


  const elLeft = document.querySelector(".swiper-looks-left");
  if (!elLeft) return;

  const swiperLooksLeftOpt = {
    spaceBetween: 0,
    slidesPerView: 1,
    // mousewheel: {
    //   sensitivity:1,
    //   releaseOnEdges:true,
    // },
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
      swiper: swiperLooksRight
    },
    navigation: {
      nextEl: ".swiper-looks-left .swiper-button-next",
      prevEl: ".swiper-looks-left .swiper-button-prev"
    }
  };

  swiperLooksLeft = new Swiper(elLeft, swiperLooksLeftOpt);
  swiperLooksLeft.on("slideChange", slideLeftChange); 
  slideLeftChange(true);
 
};


/******************************************************************************/

const goToZoomMode = (e) => {
  const slideId = e.currentTarget.getAttribute('data-id');
  const mode = document.querySelector('#content');
  mode.classList.remove('list');
  mode.classList.add('zoom');

  swiperLooksLeft && swiperLooksLeft.slideTo(slideId-1);
  
  window.dispatchEvent(new Event('resize'));

}

const goToListMode = () => {
  const mode = document.querySelector('#content');
  mode.classList.remove('zoom');
  mode.classList.add('list');

  window.dispatchEvent(new Event('resize'));

}

const initModes = () => {


  const toZoomMode = document.querySelectorAll(".swiper-looks .slide-look");
  const toListMode = document.querySelector(".swiper-button-all");

  toZoomMode && toZoomMode.forEach((e) => {
    e.addEventListener('click', goToZoomMode);
   });

   toListMode && toListMode.addEventListener('click', goToListMode);
   goToListMode();
}

export const initSliders = () => {
  initSliderLooks();
  initSliderVideos();

  initSliderLooksDetails();
  initModes();
};
